export default {
    white: '#FFFFFF',
    darkWhite: '#FCFCFD',
    darkerWhite: '#F5F4F6',
    darkestWhite: '#EBEAED',
    mostDarkestWhite: '#DEDCE1',

    ink: '#170C3A',
    lightInk: '#8F8A9B',
    lighterInk: '#B1ADB9',
    lighestInk: '#C7C4CD',
    inkTransparent: 'rgba(23, 12, 58, 0.7)',

    black: '#000',
    blackDark: '#272425',
    gray: '#EAEEF5',

    darkerBlue: '#0F1B23',
    darkBlue: '#2F55CC',
    blue: '#365DF0',
    lightBlue: '#9AAEF7',
    lighterBlue: '#B9C6FA',
    lighestBlue: '#CAD6FC',
    mostLighestBlue: '#E1E7FD',

    darkerRed: '#A53F3F',
    darkRed: '#CC4C4C',
    red: '#ef5350',
    lightRed: '#FCAEAC',
    lighterRed: '#FCC6C5',
    lighestRed: '#FCD7D6',
    mostLighestRed: '#FEEFEE',

    darkerGreen: '#0E995D',
    darkGreen: '#10B26C',
    green: '#12DB89',
    lightGreen: '#88EDC4',
    lighterGreen: '#B7F7D8',
    lighestGreen: '#CFF9E6',
    mostLighestGreen: '#E7FBF3',
};